import { Link, useParams, useNavigate } from "react-router-dom"; // useNavigate instead of Navigate
import "react-phone-input-2/lib/style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, localUrl } from "../../config/baseUrl";
import moment from "moment";
import Swal from "sweetalert2";

export default function ViewReport() {
  const { id } = useParams();
  const [message, setMessage] = useState(null);
  const navigate = useNavigate(); // <-- initialize navigate

  useEffect(() => {
    fetchMessage();
  }, []);

  const fetchMessage = async () => {
    try {
      const response = await axios.get(
        // `${localUrl}/admin/report/details/${id}`, {
        `${baseUrl}/admin/report/details/${id}`, {

        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setMessage(response?.data.data || {});
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
        //   `${localUrl}/admin/report/delete/${id}`, {
          `${baseUrl}/admin/report/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        Swal.fire("Deleted!", "Report has been removed.", "success");
        navigate("/report-list"); 
      } catch (error) {
        Swal.fire("Error!", "Report could not be removed.", "error");
      }
    }
  };

  if (!message) return <p>Loading...</p>;

  return (
    <>
      <section className="main-sec">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-users me-2" />
                View Message
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    View Message
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-end">
            <Link to="/report-list" className="btn btn-info text-white">
              <i className="fa fa-arrow-left me-1"></i>
              Back
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td>Title</td>
                      <td>{message.title}</td>
                    </tr>
                    <tr>
                      <td>Message</td>
                      <td
                        className="text-wrap"
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {message.message}
                      </td>
                    </tr>
                    <tr>
                      <td>Name</td>
                      <td>{message.name}</td>
                    </tr>
                    <tr>
                      <td>User Id</td>
                      <td>{message.user_id}</td>
                    </tr>
                    <tr>
                      <td>Reported User Id</td>
                      <td>{message.reported_user_id}</td>
                    </tr>

                    <tr>
                      <td>Created At</td>
                      <td>
                        {message.created_at}
                      </td>
                      {/* <td>
                        {moment(message.created_at).format(
                          "MMM DD, YYYY, h:mm A"
                        )}
                      </td> */}
                    </tr>
                    <tr>
                      <td>Action</td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          data-toggle="modal"
                          data-target="#deleteModal"
                          onClick={() => handleDelete(message.id)}
                        >
                          <i className="fa fa-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
